export enum DefaultsSelects {
  Region,
  Country,
  Sector,
  Division,
  NoneDefaults,
}
